import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu, MessageSquare } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { AgentPanel } from "@/components/agent-panel/AgentPanel";
import { navItems, NavLink } from "./nav-items";

// DEM-45 — voice feed REMOVED from the Engineering Dashboard mobile bar.
// The PI agent vocalizes inline via its `speak` tool now, so there is no
// secondary voice surface to toggle into.
//
// DEM-48 — adds a right-side chat button that opens AgentPanel in a full-
// screen sheet. AgentPanel is the single source of truth; mobile renders
// it with `fullScreen` so the same component fills the sheet without its
// width-animating desktop chrome.
export function MobileTopBar() {
  const [navOpen, setNavOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setNavOpen(false);
    setChatOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-40 flex items-center gap-3 border-b bg-sidebar px-3 py-2.5 md:hidden">
      <Sheet open={navOpen} onOpenChange={setNavOpen}>
        <SheetTrigger asChild>
          <button
            type="button"
            aria-label="Open navigation"
            className="rounded-md p-2 text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
          >
            <Menu className="h-5 w-5" />
          </button>
        </SheetTrigger>
        <SheetContent
          side="left"
          className="flex w-72 max-w-[85vw] flex-col gap-0 bg-sidebar p-0"
        >
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <div className="border-b px-4 py-4">
            <span className="text-sm font-semibold">Dashboard</span>
          </div>
          <nav className="flex flex-1 flex-col gap-0.5 overflow-y-auto px-2 py-4">
            {navItems.map((item) => (
              <NavLink key={item.to} item={item} />
            ))}
          </nav>
        </SheetContent>
      </Sheet>

      <span className="flex-1 text-center text-sm font-semibold">Dashboard</span>

      <Sheet open={chatOpen} onOpenChange={setChatOpen}>
        <SheetTrigger asChild>
          <button
            type="button"
            aria-label="Open PI agent"
            className="rounded-md p-2 text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
          >
            <MessageSquare className="h-5 w-5" />
          </button>
        </SheetTrigger>
        <SheetContent
          side="right"
          className="flex h-full w-screen max-w-none flex-col gap-0 border-l-0 p-0 sm:max-w-none"
        >
          <SheetTitle className="sr-only">PI agent</SheetTitle>
          <AgentPanel open={chatOpen} onClose={() => setChatOpen(false)} fullScreen />
        </SheetContent>
      </Sheet>
    </header>
  );
}
